import React, { useState } from 'react';
import CalcShell, { StepsPanel } from '../CalcShell';

const KEYS = [
  ['AC','+/-','%','÷'],
  ['7','8','9','×'],
  ['4','5','6','−'],
  ['1','2','3','+'],
  ['0','.','=',''],
];

export default function BasicCalc() {
  const [display, setDisplay] = useState('0');
  const [prev, setPrev] = useState(null);
  const [op, setOp] = useState(null);
  const [waiting, setWaiting] = useState(false);

  const input = (k) => {
    if (waiting) { setDisplay(k === '.' ? '0.' : k); setWaiting(false); return; }
    if (k === '.') { if (!display.includes('.')) setDisplay(display + '.'); return; }
    setDisplay(display === '0' ? k : display + k);
  };
  const applyOp = (nextOp) => {
    const v = parseFloat(display);
    if (prev == null) setPrev(v);
    else if (op) {
      const r = compute(prev, v, op);
      setPrev(r); setDisplay(String(r));
    }
    setOp(nextOp); setWaiting(true);
  };
  const compute = (a, b, o) => {
    if (o === '+') return a + b;
    if (o === '−') return a - b;
    if (o === '×') return a * b;
    if (o === '÷') return b === 0 ? 0 : a / b;
    return b;
  };
  const equals = () => {
    if (prev == null || !op) return;
    const v = parseFloat(display);
    const r = compute(prev, v, op);
    setDisplay(String(r)); setPrev(null); setOp(null); setWaiting(true);
  };
  const clear = () => { setDisplay('0'); setPrev(null); setOp(null); setWaiting(false); };
  const negate = () => setDisplay(String(-parseFloat(display)));
  const percent = () => setDisplay(String(parseFloat(display) / 100));

  const press = (k) => {
    if (k === 'AC') return clear();
    if (k === '=') return equals();
    if (k === '+/-') return negate();
    if (k === '%') return percent();
    if (['+','−','×','÷'].includes(k)) return applyOp(k);
    if (/[0-9.]/.test(k)) return input(k);
  };

  return (
    <CalcShell look="cnet" title="Basic Calculator" subtitle="A simple 4-function calculator with percent, negate, and clear.">
      <div className="max-w-sm mx-auto">
        <div className="bg-slate-900 text-white rounded-t-lg px-4 py-6 text-right text-4xl font-mono" data-testid="basic-display">{display}</div>
        <div className="grid grid-cols-4 gap-2 bg-slate-100 p-3 rounded-b-lg">
          {KEYS.flat().filter(k => k !== '').map((k,i)=>(
            <button key={i} onClick={()=>press(k)}
              data-testid={`basic-key-${k}`}
              className={`h-14 rounded font-semibold text-lg ${
                ['+','−','×','÷','='].includes(k) ? 'bg-orange-500 text-white hover:bg-orange-600' :
                ['AC','+/-','%'].includes(k) ? 'bg-slate-300 hover:bg-slate-400' :
                'bg-white hover:bg-slate-200'
              } ${k === '0' ? 'col-span-1' : ''}`}
            >{k}</button>
          ))}
        </div>
      </div>
    </CalcShell>
  );
}
